import { render, staticRenderFns } from "./examineDetail.vue?vue&type=template&id=4e468a0c&scoped=true&"
import script from "./examineDetail.vue?vue&type=script&lang=js&"
export * from "./examineDetail.vue?vue&type=script&lang=js&"
import style0 from "./examineDetail.vue?vue&type=style&index=0&id=4e468a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e468a0c",
  null
  
)

export default component.exports